//---------------18-06-2025----------------
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../Styles/ChangePassword.css';

const ChangePassword = () => {
  const location = useLocation();

  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const b2bAuthToken = localStorage.getItem("b2bAuthToken");

    if (!b2bAuthToken) {
      setStatus('error');
      setMessage("User not logged in.");
      return;
    }

    let phoneNumber = location.state?.phoneNumber || "";

        const { oldPassword, newPassword, confirmPassword } = form;

    if (!oldPassword || !newPassword || !confirmPassword) {
      setStatus('error');
      setMessage("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setStatus('error');
      setMessage("New password and confirm password do not match.");
      return;
    }

    try {
      const response = await fetch('https://b2bdubaibackendapi.mmstourism.com/api/b2/agency/forgotPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phoneNumber,
          oldPassword,
          newPassword,
          confirmPassword
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage("Password updated successfully.");
        setForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        setStatus('error');
        setMessage(result.message || "Something went wrong.");
      }
    } catch (error) {
      setStatus('error');
      setMessage("Error updating password.");
    }
  };

  return (
    <div className="changepassword-form">
      <div className="changepassword-title">Change Password</div>
      <div className="changepassword-note">Use the form below to change your password</div>

      <div className="changepassword-textfield">
        <label>OLD PASSWORD</label>
        <input
          type="password"
          name="oldPassword"
          value={form.oldPassword}
          onChange={handleChange}
        />
      </div>

      <div className="changepassword-textfield">
        <label>NEW PASSWORD</label>
        <input
          type="password"
          name="newPassword"
          value={form.newPassword}
          onChange={handleChange}
        />
      </div>

      <div className="changepassword-textfield">
        <label>CONFIRM PASSWORD</label>
        <input
          type="password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
        />
      </div>

      <button className="changepassword-submit" onClick={handleSubmit}>
        Submit
      </button>

      {message && (
        <div className={`changepassword-message ${status}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
